// StatusPill — the single source of truth for material_status badges.
//
// Tables render <StatusPill/>; the inline chat (whose message content is an
// HTML string) uses statusPillHtml(). Both map a material_status to the shared
// `sp-*` badge classes in index.css, so the chat and the queue/log stay in sync.

import React from 'react';

// material_status → shared `sp-*` badge class.
const MATERIAL_STATUS_CLASS: Record<string, string> = {
  'New':            'sp-pending',
  'Processing':     'sp-v',
  'To Verify':      'sp-o',
  'Matched':        'sp-r',
  'No Job Found':   'sp-e',
  'Received Short': 'sp-w',
  'On Hold':        'sp-h',
  'Follow Ups': 'sp-m',
};

export function materialStatusClass(status: string): string {
  return MATERIAL_STATUS_CLASS[status] ?? 'sp-pending';
}

export function StatusPill({ status, className = '' }: { status: string; className?: string }) {
  return <span className={`sp text-xs whitespace-nowrap ${materialStatusClass(status)} ${className}`.trim()}>{status}</span>;
}

// HTML-string variant for chat message content (rendered via dangerouslySetInnerHTML).
export function statusPillHtml(status: string): string {
  return `<span class="sp ${materialStatusClass(status)}">${status}</span>`;
}
